import cloneDeep from 'lodash/cloneDeep';
import { GraphMode } from '../../constants';
import { canAnyNodeBeCloned, getClonableNodes, getModel, updateGlobal } from '../../utils';
import { BaseCommand, baseCommand } from '../base';

export const copyCommand: BaseCommand = {
  ...baseCommand,

  canExecute(graph) {
    if (graph.getCurrentMode() === GraphMode.Readonly) return false;
    // Can be executed if at least one of the nodes can be cloned
    return canAnyNodeBeCloned(this.getSelectedNodes(graph) || []);
  },

  canUndo() {
    return false;
  },

  execute(graph) {
    const nodesToCopy = getClonableNodes(this.getSelectedNodes(graph)).map(getModel);
    updateGlobal(graph, { clipboard: { models: cloneDeep(nodesToCopy) } });
  },

  shortcuts: [
    ['metaKey', 'c'],
    ['ctrlKey', 'c'],
  ],
};

export default copyCommand;
